import React from 'react';
import { CellTypes } from '../table.types';
import TableRow from '../TableRow/table-row';
import { TableRowProps } from '../TableRow/table-row.types';

// Create the footer rows as Table Rows
const createFooterRows = (props: TableRowProps) => {
  const { columnData, data, tableIndex, dark, isLoading } = props;

  const rows = data?.map((row: unknown, i: number) => (
    <TableRow
      dark={dark}
      tableIndex={tableIndex}
      data={row as unknown[]}
      columnData={columnData}
      type={CellTypes.FOOTER}
      key={`footer-row-${i}`}
      isLoading={isLoading}
    />
  ));

  return rows;
};

const TableFooter = (props: TableRowProps) => {
  const footerRows = createFooterRows(props);

  return <tfoot>{footerRows}</tfoot>;
};

export default TableFooter;
